import 'rxjs/add/operator/map';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, delay, mergeMap, retryWhen, tap } from 'rxjs/operators';
import { NotificationToastService } from './notification-toast.service';

@Injectable()
export class DataService {

  apiUrl: string;
  retryLimit = 3;

  constructor( private http: HttpClient,
               private notificationToastService: NotificationToastService  ) {
    this.apiUrl = environment.api;
  }

  public get<T>(actionUrl: string, params: any = null): Observable<T> {

    let attempt = 0;

    if (params) {
      return this.http.get<T>(this.apiUrl + actionUrl, { params: params });
      // .pipe(
      //   this.delayedRetry(10000, 3),
      //   catchError(err => {
      //      throw err;
      //   }),
      // );
    } else {
      return this.http.get<T>(this.apiUrl + actionUrl);
      // .pipe(
      //   this.delayedRetry(10000, 3),
      //   catchError(err => {
      //      throw err;
      //   }),
      // );
    }
  }

  public post<T>(actionUrl: string, data: any): Observable<T> {
    return this.http.post<T>(this.apiUrl + actionUrl, data);
    // .pipe(
    //   this.delayedRetry(10000, 3),
    //   catchError(err => {
    //      throw err;
    //   }),
    // );
  }

  public delete<T>(actionUrl: string, data: any): Observable<T> {
    return this.http.delete<T>(this.apiUrl + actionUrl, data)
    .pipe(
      this.delayedRetry(10000, 3),
      catchError(err => {
         throw err;
      }),
    );
  }

  private isConnectionError(error: any): boolean {
    console.log(error);
    const isError = error.status === 504 || error.status === 0 || error.status === 500 || error.status === 502;
    if (isError){
      this.notificationToastService.info('No hay conexión con el servidor', 'Error conexión');
    }
    console.log('isError', isError);
    return isError;
  }

  delayedRetry(delayMs:number, maxRetry:number) {
    let retries = maxRetry;
    return (src:Observable<any>) =>
    src.pipe(
       retryWhen((errors:Observable<any>)=> errors.pipe(
       delay(delayMs),
       mergeMap(error =>retries -- > 0 && this.isConnectionError(error) ?
       of(error):throwError(error))
      ))
    )
  }

}


